var map = {
	"./audio-placeholder": 637,
	"./audio-placeholder.png": 637,
	"./avatar-missing": 417,
	"./avatar-missing.png": 417,
	"./avatar-missing.svg": 711,
	"./halloween/clouds": 638,
	"./halloween/clouds.png": 638,
	"./halloween/halloween-emblem": 656,
	"./halloween/halloween-emblem.svg": 656,
	"./halloween/spider": 689,
	"./halloween/spider.svg": 689,
	"./halloween/spiderweb": 690,
	"./halloween/spiderweb.svg": 690,
	"./halloween/starfield": 691,
	"./halloween/starfield.png": 691,
	"./halloween/twinkle": 692,
	"./halloween/twinkle.svg": 692,
	"./header-missing": 613,
	"./header-missing.png": 613,
	"./soapbox-logo": 614,
	"./soapbox-logo-white": 615,
	"./soapbox-logo-white.svg": 615,
	"./soapbox-logo.svg": 614,
	"./sprite-post-functions": 693,
	"./sprite-post-functions.png": 693,
	"./video-placeholder": 694,
	"./video-placeholder.png": 694,
	"./void": 695,
	"./void.png": 695,
	"./web-push/web-push-icon_expand": 696,
	"./web-push/web-push-icon_expand.png": 696,
	"./web-push/web-push-icon_favourite": 697,
	"./web-push/web-push-icon_favourite.png": 697,
	"./web-push/web-push-icon_reblog": 698,
	"./web-push/web-push-icon_reblog.png": 698
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 710;